// @ts-strict-ignore
import { useTheme } from "@emotion/react";
import { colorProfileMapper } from "aviary-tokens";

import type { BoxProps } from "./Box.types";

import * as styles from "./Box.styles";

/**
 * Documentation:
 * https://aviary.docs.fullscript.cloud/components/layout/Box
 *
 * @deprecated Use `Box` from `@fullscript/aviary-web` instead.
 */
const Box = ({ isColor = null, isGutterless = false, padding = "normal", ...props }: BoxProps) => {
  const currentTheme = useTheme();
  const themeColors = colorProfileMapper(currentTheme);

  const { children, layoutStyles, accentColor, isBordered: _isBorderedUnused, ...rest } = props;

  const boxStyles = [
    styles.box,
    styles.padding[padding],
    isGutterless && styles.gutterless,
    isColor && styles.themedColorStyles(themeColors[isColor]),
    accentColor && styles.accentColor[accentColor],
  ];

  return (
    <section css={[boxStyles, layoutStyles]} {...rest}>
      {children}
    </section>
  );
};

export { Box };
